<template>
  <div class="flex justify-center items-center min-h-[50vh]">
    <div class="text-center text-gray-400">
      функціонал в розробці
    </div>
  </div>
</template>

<script>
export default {
  name: "GpsView",
};
</script>
